
const state = {
    getRouter: false,
}

const getters = {
    isGetRouter: state => {
        return state.getRouter === true
    }
}

const actions = {

}

const mutations = {
    setGetRouter(state, status) {
        state.isGetRouter = status
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/route.js